import * as React from 'react';
import IconBase, { IconBaseProps } from '../components/Icons/IconBase';
const props = {};

const SvgTurnRight = (allProps: IconBaseProps) => {
  return (
    <IconBase {...allProps}>
      <svg
        width="1em"
        height="1em"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <path
          d="M1.87213 13.2023C1.20823 12.5384 1.20823 11.4621 1.87213 10.7982L10.7817 1.88862C11.4456 1.22473 12.5219 1.22473 13.1858 1.88862L22.0954 10.7982C22.7593 11.4621 22.7593 12.5384 22.0954 13.2023L13.1858 22.1119C12.5219 22.7758 11.4456 22.7758 10.7817 22.1119L1.87213 13.2023Z"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M14.1712 13.0289L16.2389 10.9611L14.1711 9.00024"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M16 11.0002H10.6701L10.1619 11.0002C9.04394 11.0002 8.14308 11.9166 8.16215 13.0344L8.1701 13.5002V14.5002"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </IconBase>
  );
};

SvgTurnRight.displayName = 'SvgTurnRight';
export default SvgTurnRight;
